export default __webpack_public_path__ + "static/BACK-3a620f5a8414b82752d4c48ca987bcee.png";